import { modifier } from 'ember-modifier';

export default modifier(
  (element, [triggerValue, iconValue]) => {
    let triggerElem = element.querySelector('.ember-power-select-trigger');
    if (triggerValue && triggerElem) {
      triggerElem.setAttribute('data-qa-element', triggerValue);
    }
    let iconElem = element.querySelector('.ember-power-select-status-icon');
    if (iconValue && iconElem) {
      iconElem.setAttribute('data-qa-element', iconValue);
    }
  },
  { eager: false },
);
